import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import { createParser } from '../core/parser.js';
import '../core/compose.js';
import '../core/style-function.js';
import '../core/system.js';
import './typography.js';
import './transition.js';
import './margin.js';
import './padding.js';
import './space.js';
import './shadow.js';
import './animation.js';
import './background.js';
import './border.js';
import './color.js';
import './flexbox.js';
import './grid.js';
import './layout.js';
import './other.js';
import './position.js';
import { parsers } from './parsers-config.js';

const pseudoSelectors = {
  _hover: ['&:hover', '&[data-hover]'],
  _active: ['&:active', '&[data-active]'],
  _focus: ['&:focus', '&[data-focus]'],
  _highlighted: ['&[data-highlighted]'],
  _focusWithin: ['&:focus-within'],
  _focusVisible: ['&:focus-visible'],
  _disabled: ['&[disabled]', '&[aria-disabled=true]', '&[data-disabled]'],
  _readOnly: ['&[aria-readonly=true]', '&[readonly]', '&[data-readonly]'],
  _before: ['&::before'],
  _after: ['&::after'],
  _empty: ['&:empty'],
  _expanded: ['&[aria-expanded=true]', '&[data-expanded]'],
  _checked: ['&:checked', '&[aria-checked=true]', '&[data-checked]'],
  _grabbed: ['&[aria-grabbed=true]', '&[data-grabbed]'],
  _pressed: ['&[aria-pressed=true]', '&[data-pressed]'],
  _invalid: ['&[aria-invalid=true]', '&[data-invalid]'],
  _valid: ['&[data-valid]', '&[data-state=valid]'],
  _loading: ['&[data-loading]', '&[aria-busy=true]'],
  _selected: ['&[aria-selected=true]', '&[data-selected]'],
  _hidden: ['&[hidden]', '&[data-hidden]'],
  _even: ['&:nth-of-type(even)'],
  _odd: ['&:nth-of-type(odd)'],
  _first: ['&:first-of-type'],
  _last: ['&:last-of-type'],
  _notFirst: ['&:not(:first-of-type)'],
  _notLast: ['&:not(:last-of-type)'],
  _visited: ['&:visited'],
  _activeLink: ['&[aria-current=page]'],
  _indeterminate: ['&:indeterminate', '&[aria-checked=mixed]', '&[data-indeterminate]'],
  _placeholder: ['&::placeholder'],
  _fullScreen: ['&:fullscreen'],
  _selection: ['&::selection']
};

/**
 * Creates a function that generates styles based on a pseudo selector.
 * @param property The pseudo selector to generate styles for.
 * @returns The generated styles.
 */
const createPseudoValue = property => (_, _1, props) => {
  const result = {};
  const properties = pseudoSelectors[property];
  if (props !== null && props !== void 0 && props[property]) {
    result[properties.join(', ')] = parsers(_objectSpread2({
      theme: props.theme
    }, props[property]));
  }
  return result;
};
const pseudo = props => {
  const config = {
    _active: createPseudoValue('_active'),
    _activeLink: createPseudoValue('_activeLink'),
    _after: createPseudoValue('_after'),
    _before: createPseudoValue('_before'),
    _checked: createPseudoValue('_checked'),
    _empty: createPseudoValue('_empty'),
    _even: createPseudoValue('_even'),
    _expanded: createPseudoValue('_expanded'),
    _first: createPseudoValue('_first'),
    _focus: createPseudoValue('_focus'),
    _focusVisible: createPseudoValue('_focusVisible'),
    _focusWithin: createPseudoValue('_focusWithin'),
    _fullScreen: createPseudoValue('_fullScreen'),
    _grabbed: createPseudoValue('_grabbed'),
    _hidden: createPseudoValue('_hidden'),
    _highlighted: createPseudoValue('_highlighted'),
    _indeterminate: createPseudoValue('_indeterminate'),
    _invalid: createPseudoValue('_invalid'),
    _last: createPseudoValue('_last'),
    _loading: createPseudoValue('_loading'),
    _notFirst: createPseudoValue('_notFirst'),
    _notLast: createPseudoValue('_notLast'),
    _odd: createPseudoValue('_odd'),
    _placeholder: createPseudoValue('_placeholder'),
    _pressed: createPseudoValue('_pressed'),
    _readOnly: createPseudoValue('_readOnly'),
    _selected: createPseudoValue('_selected'),
    _selection: createPseudoValue('_selection'),
    _valid: createPseudoValue('_valid'),
    _visited: createPseudoValue('_visited'),
    _hover: createPseudoValue('_hover'),
    _disabled: createPseudoValue('_disabled')
  };
  return createParser(config)(props);
};

export { pseudo, pseudoSelectors };
